(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('fieldMatches', function () {
        function valueByKeys(data, keys) {
            if (keys.length === 0) {
                return;
            }
            if (keys.length === 1) {
                return data[keys[0]];
            }
            if (_(data[keys[0]]).isUndefined()) {
                return;
            }
            return valueByKeys(data[keys[0]], _(keys).rest());
        }
        function fieldEqual(data, keys, value) {
            if (keys.length === 0) {
                return false;
            }
            if (keys.length === 1) {
                return data[keys[0]] === value;
            }
            if (_(data[keys[0]]).isUndefined()) {
                return false;
            }
            return fieldEqual(data[keys[0]], _(keys).rest(), value);
        }
        function fieldContains(data, key, value) {
            var keyData = valueByKeys(data, key);
            if (!_(keyData).isString() || !_(value).isString()) {
                return false;
            }
            return keyData.indexOf(value) !== -1;
        }
        function fieldPartOf(data, key, value) {
            var keyData = valueByKeys(data, key);
            if (!_(keyData).isString() || !_(value).isString()) {
                return false;
            }
            return value.indexOf(keyData) !== -1;
        }
        return {
            result: function (d, key, compareWith) {
                var data = {};
                if (typeof d !== 'object') {
                    data[key] = d;
                } else {
                    data = d;
                }
                var keys = key.split('.');
                if (compareWith && compareWith.src_key) {
                    keys = compareWith.src_key.split('.');
                }
                var value = compareWith;
                if (compareWith && compareWith.operator) {
                    if (compareWith.key) {
                        value = valueByKeys(data, compareWith.key.split('.'));
                    } else {
                        value = compareWith.value;
                    }
                }
                if (compareWith && compareWith.operator === 'not_equal') {
                    return !fieldEqual(data, keys, value);
                }
                if (compareWith && compareWith.operator === 'equal') {
                    return fieldEqual(data, keys, value);
                }
                if (compareWith && compareWith.operator === 'contains') {
                    return fieldContains(data, keys, value);
                }
                if (compareWith && compareWith.operator === 'partof') {
                    return fieldPartOf(data, keys, value);
                }
                if (compareWith && compareWith.operator === 'not_partof') {
                    return !fieldPartOf(data, keys, value);
                }
                if (compareWith && compareWith.operator === 'defined') {
                    return !_(valueByKeys(data, keys)).isUndefined();
                }
                return fieldEqual(data, keys, compareWith);
            }
        };
    });
}());